import React, { useContext, useState } from "react"
import Loader1 from "../../interceptors/loader-interceptor"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { withPrefix } from "gatsby"
import {
  cpgPaymentVerification,
  downloadPaymentReceipt,
  saveApplication,
} from "../../services/apiservice"
import * as lookup from "../../../static/lookup.json"
import { errorToastr } from "../../services/error-handler"
import { ErrorContext } from "../context/errorContext"
import styled from "styled-components"

function GiftCityPaymentStatus(props) {
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [giftCityPaymentTransaction, setGiftCityPaymentTransaction] = useState(
    props?.giftCityPaymentTransaction || {}
  )
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [b64Receipt, setB64Receipt] = useState()

  const getDownloadPaymentReceiptData2 = async () => {
    const paymentTxnId = giftCityPaymentTransaction?.paymentTxnId
    const res = await downloadPaymentReceipt(
      journeyState.journeyId,
      paymentTxnId
    )
    if (res.status) {
      setB64Receipt(res.data)
      pdfDownload(res.data)
    } else {
      errorToastr("Payment data does not exist!")
    }
  }

  const downloadReceipt = () => {
    if (b64Receipt) {
      pdfDownload(b64Receipt)
    } else {
      getDownloadPaymentReceiptData2()
    }
  }

  const pdfDownload = b64Receipt => {
    const downloadLink = document.createElement("a")
    downloadLink.href = `data:application/pdf;base64,${b64Receipt}`
    const fileName = `${
      lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""
    }_Receipt_${journeyState.applicationNo}.pdf`
    downloadLink.download = fileName
    downloadLink.click()
  }

  const handleClick = () => {
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex + 1,
        lastSection: 0,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      },
    }
    saveApplication(sendPayload)
      .then(res => {
        props.setCurrentPageIndex(prev => prev + 1)
        props.setCurrentSectionIndex(0)
        setErrorState({})
        setErrorState({})
      })
      .catch(err => {
        console.log(err, "err in saveApplication")
      })
  }

  const retryCpgIntegration = () => {
    cpgPaymentVerification({ journeyId: journeyState.journeyId })
      .then(res => {
        setGiftCityPaymentTransaction({
          ...res.data,
          paymentStatus: true,
        })
      })
      .catch(err => {
        const requestPayload = err?.response.data.requestPayload || {}
        setGiftCityPaymentTransaction({
          ...requestPayload,
          paymentStatus: false,
        })
      })
  }

  const InputContainer = styled.div`
    display: block;
    flex-direction: column;
    margin: 15px 0;
    position: relative;
    box-sizing: border-box;
    font-size: 15px;
    color: #505050;
    float: left;

    & > input {
    }
    & > label {
      margin-left: 8px;
      margin-bottom: 5px;
      color: #505050;
      font-size: 16px;
      background-color: #fff;
      padding: 2px 5px;
      /* z-index: 999; */
      position: relative;
      display: inline-block;
      cursor: default;
      max-width: 100%;
      min-height: 2rem;
    }
  `

  return (
    <>
      {giftCityPaymentTransaction?.paymentStatus ? (
        <>
          <>
            <Loader1 />
            <style>
              {`
                  .input-group.date .input-group-addon{
                    background:none;
                  }
            
                  @media (max-width: 767px){
        
                    .form-group {
                      margin-bottom: 34px;
                    }
                    
                  }
                  .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                    margin-left:-2px;
                  }
                  ::-ms-clear {
                    display: none;
                  }    
                  .d-none{
                    display: none;
                  }   
                  .br-0{
                    border-radius: 0px !important;
                  }
                      `}
            </style>

            <div className="landing-page1-design">
              <div className="container">
                <div className="row">
                  <div className="iselect-box-design">
                    <div className="iselect-padding">
                      <div className="payment-receipt-structure-design">
                        <div className="payment-receipt-structure-design-healine">
                          {" "}
                          <img src={withPrefix("/images/success-icon.png")} />
                          {/* <h2>Congratulations!</h2> */}
                          <h3>Payment details acknowledged and same is subject to realization</h3>
                          <div className="line"></div>
                        </div>
                        <div className="download-receipt-structure">
                          <div className="ap-receipt-stucture">
                            {" "}
                            <span>Application Number</span>
                            <h2>{journeyState.applicationNo}</h2>
                          </div>
                          <a style={{ color: "#fff", textDecoration: "none" }}>
                            <div className="download-ap-receipt-stucture">
                              {" "}
                              <img
                                src={withPrefix("/images/download-receipt.png")}
                                style={{ cursor: "pointer" }}
                                aria-hidden="true"
                                onClick={downloadReceipt}
                              />
                              <p
                                aria-hidden="true"
                                onClick={downloadReceipt}
                                style={{ cursor: "pointer" }}
                              >
                                Click to
                                <br />
                                Download Receipt
                              </p>
                            </div>
                          </a>{" "}
                        </div>
                        <div className="clearfix"></div>
                        <div className="emil-structure">
                          <p>
                            Payment Receipt has also been sent to your
                            registered email ID.
                          </p>
                          <p>
                            You are only a few minutes away from completing your
                            application. Please click on Proceed to continue
                            with your application.
                          </p>
                        </div>
                      </div>

                      <div className="iselect-mg-bottom hidden-desktop-screen">
                        <div className="col-md-12">
                          <div className="but-center text-center">
                            <div
                              className="previous-btn cen"
                              style={{ padding: "0px" }}
                            >
                              <a style={{ padding: "0px" }}>
                                {" "}
                                <button
                                  type="submit"
                                  value="button2"
                                  name="button2"
                                  style={{
                                    backgroundColor: "transparent",
                                    padding: "14px 40px",
                                    border: "none",
                                    borderRadius: "10px",
                                    color: "#fff",
                                  }}
                                  onClick={handleClick}
                                >
                                  Complete Application
                                </button>{" "}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
              <div className="iselect-mg-bottom">
                <div className="col-md-12">
                  <div className="but-center text-center">
                    <div
                      className="previous-btn cen"
                      style={{
                        width: "auto",
                        padding: "0",
                        lineHeight: "50px",
                      }}
                    >
                      <a aria-hidden="true" onClick={handleClick}>
                        {" "}
                        <button
                          type="submit"
                          value="button2"
                          name="button2"
                          style={{
                            backgroundColor: "transparent",
                            padding: "0px 10px",
                            border: "none",
                            color: "#fff",
                            width: "initial",
                            margin: "0",
                          }}
                        >
                          Complete Application
                        </button>{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </>
      ) : (
        <>
          <Loader1 />
          <style>
            {`
                  .input-group.date .input-group-addon{
                    background:none;
                  }
            
                  @media (max-width: 767px){
        
                    .form-group {
                      margin-bottom: 34px;
                    }
                    
                  }
                  .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                    margin-left:-2px;
                  }
                  ::-ms-clear {
                    display: none;
                  }    
                  .d-none{
                    display: none;
                  }   
                  .br-0{
                    border-radius: 0px !important;
                  }
                      `}
          </style>
          <div className="landing-page1-design">
            <div className="container">
              <div className="row">
                <div className="col-md-12 ">
                  <div className="iselect-box-design">
                    <div className="heading-design">
                      <div className="iselect-padding left-side-head ckyc-w">
                        <h1 className="iselect-heading">
                          Unsuccessful Transaction
                        </h1>
                      </div>
                      <div className="app-quatation nri-mt-space hidden-desktop-screen">
                        <div className="application-design-number">
                          Application Number: {journeyState.applicationNo}
                        </div>
                      </div>
                    </div>

                    <div className="iselect-padding payment-design successful-page">
                      <div className="success-content">
                        {" "}
                        <img src="images/unsuccess.png" />
                        <p style={{ marginTop: "15px" }}>
                          Reciept creation unsuccessful. Please try again.
                        </p>
                      </div>
                      <div className="input-payment">
                        <div className="iselect-mg-bottom row">
                          <div className="col-md-4 col-xs-12 all-box-padding-right">
                            <InputContainer className="form-group">
                              <label className="input-label">
                                Transaction Status:
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="tstatus"
                                // required={true}
                                placeholder={
                                  journeyState.paymentDecryptData?.status ||
                                  "FAIL"
                                }
                                disabled={true}
                                id={1}
                              ></input>
                            </InputContainer>
                          </div>
                          <div className="col-md-4 col-xs-12 all-box-padding-middle">
                            <InputContainer className="form-group">
                              <label className="input-label">
                                Transaction Date & Time:
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="tdate"
                                placeholder={
                                  giftCityPaymentTransaction?.applicationLaunchDate ||
                                  "NA"
                                }
                                disabled={true}
                                id={1}
                              ></input>
                            </InputContainer>
                          </div>
                          <div className="col-md-4 col-xs-12 all-box-padding-left">
                            <InputContainer className="form-group">
                              <label className="input-label">Paid From:</label>
                              <input
                                className="form-control"
                                type="text"
                                name="pfrom"
                                // required={true}
                                placeholder={
                                  journeyState.paymentDecryptData
                                    ?.paymentMethod || "NA"
                                }
                                disabled={true}
                                id={1}
                              ></input>
                            </InputContainer>
                          </div>
                        </div>
                        <div
                          className="iselect-mg-bottom row"
                          style={{ justifyContent: "start" }}
                        >
                          <div className="col-md-4 col-xs-12 all-box-padding-right">
                            <InputContainer className="form-group">
                              <label className="input-label">
                                Transaction Reference Number:
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="trefno"
                                placeholder={
                                  giftCityPaymentTransaction?.transactionDetails
                                    ?.transactionid || "NA"
                                }
                                disabled={true}
                                id={1}
                              ></input>
                            </InputContainer>
                          </div>
                          <div className="col-md-4 col-xs-12 all-box-padding-middle">
                            <InputContainer className="form-group">
                              <label className="input-label">
                                Payment Amount ( $):
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="pamount"
                                placeholder={
                                  giftCityPaymentTransaction?.amount ||
                                  journeyState.premium ||
                                  "NA"
                                }
                                disabled={true}
                                id={1}
                              ></input>
                            </InputContainer>
                          </div>
                        </div>
                      </div>
                      <div
                        className="iselect-mg-bottom hidden-desktop-screen"
                        style={{ marginTop: "20px" }}
                      >
                        <div className="col-md-12">
                          <div className="but-center text-right">
                            <div className="submit-btn cen">
                              {" "}
                              <a
                                aria-hidden="true"
                                onClick={() => {
                                  retryCpgIntegration()
                                }}
                              >
                                TRY AGAIN
                              </a>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="clearfix"></div>
                    {/* <!--mobile view button--> */}
                    <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
                      <div className="iselect-mg-bottom">
                        <div className="col-md-12">
                          <div className="but-center text-center">
                            <div
                              className="submit-btn cen"
                              style={{ marginLeft: "5px" }}
                            >
                              {" "}
                              <a
                                aria-hidden="true"
                                onClick={() => {
                                  retryCpgIntegration()
                                }}
                              >
                                TRY AGAIN
                              </a>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default GiftCityPaymentStatus
